/* eslint-disable */
const _creatFun = (callback) => {
    const funName = `__grounds_${Number(Math.floor(Math.random() * 10000000000)).toString(36)}`;

    window[funName] = (args) => {
        callback(args);
    };

    return funName;
};

const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        return '';
        // console.error(e);
    }

    return value;
};

// 自定义统计上报
const sendCustomStatistics = (type, params) => {
    if (typeof window !== 'object') {
        return false;
    }
    const clientPageInfo = {
        rnum: window?.grounds?.getPageInfo?.()?.getRnum?.() || getQuery(location.href, 'rnum') || '',
        ref: window?.grounds?.getPageInfo?.()?.getRef?.() || getQuery(location.href, 'ref') || '',
        showtype: window?.grounds?.getPageInfo?.()?.getShowtype?.() || getQuery(location.href, 'showtype') || '',
        tag: window?.grounds?.getPageInfo?.()?.getTag?.() || getQuery(location.href, 'tag') || '',
    };
    const NODEENV = typeof NODE_ENV === 'undefined' ? window.NODE_ENV : NODE_ENV;
    const isUrlDev = location.href.includes('devSta=1');

    if (NODEENV === 'development' || NODEENV === 'staging' || isUrlDev) {
        const script = document.createElement('script');

        script.src = `http://fe.custom.ifeng.com/appsta.js?${type}=${JSON.stringify(params)}&clientPageInfo=${JSON.stringify(clientPageInfo)}`;
        script.async = 'async';
        document.body.appendChild(script);
    } else {
        console.log(`统计上报 ${type}=${JSON.stringify(params)} clientPageInfo=${JSON.stringify(clientPageInfo)}`);
    }
};
/**
 * 移动端统计组件
 * 
 */
const Grounds = {
    actionStat: (params) => {
        window?.grounds?.actionStat?.(JSON.stringify(params));
        sendCustomStatistics('action', params);
    },
    on: (eventName, callbackName) => {
        window?.grounds?.on?.(eventName, callbackName);
    },
    backButton: (isShow, callbackName) => {
        window?.grounds?.backButton?.(isShow, callbackName);
    },
    buildCustomTopBanner: (options, callbackName) => {
        window?.grounds?.buildCustomTopBanner?.(JSON.stringify(options), callbackName);
    },
    close: () => {
        window?.grounds?.close?.();
    },
    closeNoAnimation: () => {
        window?.grounds?.closeNoAnimation?.();
    },
    isCollected: (options, callbackName) => {
        window?.grounds?.isCollected?.(JSON.stringify(options), callbackName);
    },
    collect : (options, action, callbackName) => {
        window?.grounds?.collect?.(
            JSON.stringify(options),
            action,
            callbackName,
        );
    },
    commentStat: (params) => {
        window?.grounds?.commentStat?.(JSON.stringify(params));
        sendCustomStatistics('comment', params);
    },
    configBackUrl: (params) => {
        window?.grounds?.configBackUrl?.(JSON.stringify(params));
    },
    disableBounceEffect: (value) => {
        window?.grounds?.disableBounceEffect?.(value);
    },
    /**
     * 打开新的webview页面
     * params有两种传参方式
     * 第一种 {object} params
     *  @param {string}  url  跳转地址
     *  @param {string}  type 跳转类型
     * 第二种 {object} params
     *  @param {object} link
     *      @param {string} url 跳转地址
     *      @param {string} type 跳转类型
     *  @param {object} pageLogParams
     *      @param {string} rnum 跳转地址
     *      @param {string} ref 跳转类型
     *      @param {string} showtype 跳转地址
     *      @param {string} tag 跳转类型 
     * url参数经过了特殊处理，如rnum、ref、showtype和tag全部传值
     * 
     * dispatch方法的url值为:https://example.com?rnum=xxx&ref=xxx&showtype=xxx&tag=xxx&needpage=1&isFull=0&ifengsp=1
     * dispatchByLink方法的url值为:https://example.com?needpage=1&isFull=0&ifengsp=1
     * 
     */
    dispatch: (params) => {
        const isSupportDispatchByLink = window?.grounds?.dispatchByLink;
        const type = params?.type || params?.link?.type || '';
        let url = params?.url || params?.link?.url || '';
        const urlParamsArray = [];
        const urlParamsObj = {
            needpage: getQuery(url, 'needpage') ? '' : '1',
            isFull: getQuery(url, 'isFull') ? '' : '0',
            ifengsp: getQuery(url, 'ifengsp') ? '' : '1',
            rnum: getQuery(url, 'rnum') ? '' : params?.pageLogParams?.rnum,
            ref: getQuery(url, 'ref') ? '' : params?.pageLogParams?.ref,
            showtype: getQuery(url, 'showtype') ? '' : params?.pageLogParams?.showtype,
            tag: getQuery(url, 'tag') ? '' : params?.pageLogParams?.tag,
        }
        
        for(let key in urlParamsObj){
            if(urlParamsObj[key]) {
                urlParamsArray.push(`${key}=${urlParamsObj[key]}`);
            }
        }
        const urlParamsString = url.includes('&') || url.includes('?') ? `&${urlParamsArray.join('&')}` : urlParamsArray.join('&');
        const urlParamsMerge = url.includes('?') ? (url + urlParamsString) : `${url}?${urlParamsString}`;

        url = (urlParamsString && type === 'web') ? urlParamsMerge : url;

        if (isSupportDispatchByLink && params.pageLogParams) {
            if(params?.link?.url) {
                params.link.url = url;
            }

            window?.grounds?.dispatchByLink?.(JSON.stringify(params));
        } else {
            window?.grounds?.dispatch?.(type, url);
        }
    },
    dispatchByLink: (params) => {
        window?.grounds?.dispatchByLink?.(JSON.stringify(params));
    },
    expose: (params) => {
        window?.grounds?.expose?.(JSON.stringify(params));
        sendCustomStatistics('expose', params);
    },
    exitMaximization: () => {
        window?.grounds?.exitMaximization?.();
    },
    getCurrentOrientantion: () => {
       return window?.grounds?.getCurrentOrientantion?.();
    },
    getDeviceInfo: () => {
        return window?.grounds?.getDeviceInfo?.() || {};
    },
    getLocation: (callbackName) => {
        window?.grounds?.getLocation?.(callbackName);
    },
    getPageInfo: () => {
        return window?.grounds?.getPageInfo?.() || {};
    },
    getShowMode: () => {
        return window?.grounds?.getShowMode?.();
    },
    getStatusBarHeight: () => {
        return window?.grounds?.getStatusBarHeight?.();
    },
    getUserInfo: () => {
        return window?.grounds?.getUserInfo?.() || {};
    },
    gotoTabMenu: (tabMenu, channelId) => {
        window?.grounds?.gotoTabMenu?.(tabMenu, channelId);
    },
    grounds_webviewActiveCallback: (callback) => {
        window.grounds_webviewActiveCallback = (active) => {
            callback(active);
        };
    },
    hasH5NeedPermission: (permission) => {
        return window.grounds?.hasH5NeedPermission?.(permission);
    },
    hasNotchScreen: () => {
        return window.grounds?.hasNotchScreen?.();
    },
    isPushActivated: (callbackName) => {
        window?.grounds?.isPushActivated?.(callbackName);
    },
    keyboardScroll: (value) => {
        window?.grounds?.keyboardScroll?.(value);
    },
    maximization: () => {
        window?.grounds?.maximization?.();
    },
    newShare: (params) => {
        window?.grounds?.newShare?.(JSON.stringify(params));
        sendCustomStatistics('newShare', params);
    },
    openInput: (params, callbackName) => {
        window?.grounds?.openInput?.(JSON.stringify(params), callbackName);
    },
    openMiniAudio: (params) => {
        window?.grounds?.openMiniAudio?.(JSON.stringify(params));
    },
    closeMiniAudio: () => {
        window?.grounds?.closeMiniAudio?.();
    },
    openShare: (params) => {
        window?.grounds?.openShare?.(JSON.stringify(params));
        sendCustomStatistics('openShare', params);
    },
    openSlide: (images, index, options) => {
        window?.grounds?.openSlide?.(images, index, options);
    },
    openTongcengVideo: (url, params, callbackName) => {
        window?.grounds?.openTongcengVideo?.(url, JSON.stringify(params), callbackName);
    },
    playVideo: () => {
        window?.grounds?.playVideo?.();
    },
    pauseVideo: () => {
        window?.grounds?.pauseVideo?.();
    },
    seekVideo: (time) => {
        window?.grounds?.seekVideo?.(time);
    },
    destoryVideo: () => {
        window?.grounds?.destoryVideo?.();
    },
    openVideo: (url, params, callbackName) => {
        window?.grounds?.openVideo?.(url, JSON.stringify(params), callbackName);
    },
    pageStat: (params) => {
        const paramsData = {
            rnum: window?.grounds?.getPageInfo?.()?.getRnum?.() || getQuery(location.href, 'rnum') || '',
            ref: window?.grounds?.getPageInfo?.()?.getRef?.() || getQuery(location.href, 'ref') || '',
            showtype: window?.grounds?.getPageInfo?.()?.getShowtype?.() || getQuery(location.href, 'showtype') || '',
            tag: window?.grounds?.getPageInfo?.()?.getTag?.() || getQuery(location.href, 'tag') || '',
            pagetag: window?.grounds?.getPageInfo?.()?.getPagetag?.() || getQuery(location.href, 'pagetag') || '',
            ...params
        };

        window?.grounds?.pageStat?.(JSON.stringify(paramsData));
        sendCustomStatistics('page', paramsData);
    },
    pushState: (callbackName) => {
        window?.grounds?.pushState?.(callbackName);
    },
    pushSwitch: () => {
        window?.grounds?.pushSwitch?.();
    },
    /**
     * 客户端代理http/https请求
     * 客户端负责拼接参数、post加密、将接口请求下拉的json数据，
     *
     * @param standards  是否需要客户端的标参.
     * @param postParams post参数键值对.
     * @param getParams  get参数键值对
     * @param type       get/post/enpost
     * @param url        base url string.
     */
    nativeRequest: (params) => {
        params.getParams = params.getParams || '';
        params.postParams = params.postParams || '';
        params.standards = true;
    
        return new Promise(resolve => {
            const funName = _creatFun((data) => {
                resolve(JSON.parse(decodeURIComponent(data)));
            });
    
            grounds.requestBridge(
                params.url,
                params.postParams,
                params.getParams,
                params.type,
                params.standards,
                funName,
            );
        });
    },
    redirect2Comments: (commentsUrl, title, shareUrl, thumbnail, documentId, params) => {
        window?.grounds?.redirect2Comments?.(
            commentsUrl,
            title,
            shareUrl,
            thumbnail,
            documentId,
            JSON.stringify(params),
        );
    },
    requestH5NeedPermission: (permission, permissionInfo, callbackName) => {
        window?.grounds?.requestH5NeedPermission?.(permission, permissionInfo, callbackName);
    },
    rotate: (value) => {
        window?.grounds?.rotate?.(value);
    },
    setH5PageTouchArea: (topStart, topEnd, totalHeight) => {
        window?.grounds?.setH5PageTouchArea?.(topStart, topEnd, totalHeight);
    },
    setNoSlideArea: (params) => {
        window?.grounds?.setNoSlideArea?.(JSON.stringify(params));
    },
    setShareVisibility: (value) => {
        window?.grounds?.setShareVisibility?.(value);
    },
    shareWebCard: (imageBase64, params) => {
        window?.grounds?.shareWebCard?.(imageBase64, JSON.stringify(params));
    },
    showToast: (type, message, subMessage) => {
        window?.grounds?.showToast?.(type, message, subMessage);
    },
    userIsLogin: () => {
        return window?.grounds?.userIsLogin?.();
    },
    userLogin: () => {
        return window?.grounds?.userLogin?.();
    },
    keepscreenon: (value) => {
        window?.grounds?.keepscreenon?.(value);
    }
};

export { Grounds };
